const INFO_ICON_SELECTOR = '[data-vb-info-icon="true"]';
const VISIBLE_MODAL_SELECTOR = ".modal.show";

const isInfoIconOverlayVisible = (element) => {
    const overlayId = element.getAttribute("aria-describedby");

    if (!overlayId) {
        return false;
    }

    const overlay = document.getElementById(overlayId);
    return overlay?.classList.contains("show") ?? false;
};

const getOpenInfoIcons = (scope = document) => {
    return Array.from(scope.querySelectorAll(INFO_ICON_SELECTOR)).filter(isInfoIconOverlayVisible);
};

const dismissInfoIconOverlay = (element) => {
    const activeElement = document.activeElement;

    if (activeElement instanceof HTMLElement && element.contains(activeElement)) {
        activeElement.blur();
    }

    if (typeof element.blur === "function") {
        element.blur();
    }

    window.bootstrap?.Tooltip.getInstance(element)?.hide();
    window.bootstrap?.Popover.getInstance(element)?.hide();
};

const dismissOpenInfoIconOverlays = (event) => {
    if (event.key !== "Escape") {
        return;
    }

    const eventTarget = event.target instanceof Element ? event.target : null;
    const activeModal = eventTarget?.closest(VISIBLE_MODAL_SELECTOR);
    const openInfoIcons = activeModal ? getOpenInfoIcons(activeModal) : getOpenInfoIcons();

    if (openInfoIcons.length === 0) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    openInfoIcons.forEach((element) => {
        dismissInfoIconOverlay(element);
    });
};

document.addEventListener("keydown", dismissOpenInfoIconOverlays, true);
